/*!
 * AI Light Theme — product.js
 * Author: Luis Tapiero — © Luis Tapiero. All rights reserved.
 * Signature: LT-AIL-2026 / do not remove this notice.
 */
(() => {
  // Encoded theme metadata. Decoded at runtime so plain-text search misses it.
  const _k = ['THVpcyBUYXBpZXJv','TFQtQUlMLTIwMjY=','QUkgTGlnaHQ=','wqkgTHVpcyBUYXBpZXJv'];
  const _d = s => { try { return decodeURIComponent(escape(atob(s))); } catch(e) { return atob(s); } };
  const __LT_AIL_2026__ = Object.freeze({
    a: _d(_k[0]),         // author
    s: _d(_k[1]),         // signature
    n: _d(_k[2]),         // theme name
    c: _d(_k[3])          // copyright
  });

  // Auto-repair: re-inject author metadata if removed by tampering.
  const __ltSeal__ = () => {
    const html = document.documentElement;
    if (html.getAttribute('data-theme-author') !== __LT_AIL_2026__.a) {
      html.setAttribute('data-theme-author', __LT_AIL_2026__.a);
    }
    if (html.getAttribute('data-theme-sig') !== __LT_AIL_2026__.s) {
      html.setAttribute('data-theme-sig', __LT_AIL_2026__.s);
    }
    let m = document.head.querySelector('meta[name="author"]');
    if (!m) {
      m = document.createElement('meta');
      m.setAttribute('name', 'author');
      document.head.appendChild(m);
    }
    if (m.content !== __LT_AIL_2026__.a) m.content = __LT_AIL_2026__.a;
    let g = document.head.querySelector('meta[name="generator"]');
    if (!g) {
      g = document.createElement('meta');
      g.setAttribute('name', 'generator');
      document.head.appendChild(g);
    }
    const expectedGen = __LT_AIL_2026__.n + ' Theme by ' + __LT_AIL_2026__.a;
    if (g.content !== expectedGen) g.content = expectedGen;
  };

  try {
    console.log(
      '%c ' + __LT_AIL_2026__.n + ' %c by ' + __LT_AIL_2026__.a + ' ',
      'background:#111;color:#fff;padding:4px 8px;font-weight:bold;border-radius:3px 0 0 3px',
      'background:#EA1212;color:#fff;padding:4px 8px;border-radius:0 3px 3px 0'
    );
  } catch (e) {}

  __ltSeal__();
  document.addEventListener('DOMContentLoaded', __ltSeal__);
  window.addEventListener('load', __ltSeal__);

  // Releasit Button trigger — finds the real #rsi_buy_now_button and clicks it.
  // Allows multiple visually-independent buttons to all open the same Releasit COD form.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-lt-rsi-trigger]');
    if (!trigger) return;
    e.preventDefault();
    const rsi = document.querySelector('#rsi_buy_now_button');
    if (rsi) {
      rsi.click();
    } else {
      console.warn('[AI Light] Releasit COD button not found on page. Add a Releasit COD block to the Product template for the trigger to work.');
    }
  });

  document.querySelectorAll('[data-product]').forEach(root => {
    const mainImg = root.querySelector('[data-main-image]');
    const thumbs = root.querySelectorAll('[data-thumb]');
    const variantData = JSON.parse(root.querySelector('[data-variants]')?.textContent || '[]');
    const variantInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const optionInputs = root.querySelectorAll('input[name^="option-"]');

    thumbs.forEach(t => {
      t.addEventListener('click', () => {
        thumbs.forEach(x => x.setAttribute('aria-current', 'false'));
        t.setAttribute('aria-current', 'true');
        if (mainImg) {
          mainImg.src = t.dataset.full;
          mainImg.alt = t.querySelector('img')?.alt || '';
        }
      });
    });

    const formatMoney = cents => {
      const locale = document.documentElement.lang || 'en';
      const currency = root.dataset.currency || 'USD';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
      } catch { return (cents / 100).toFixed(2); }
    };

    const updateVariant = () => {
      const selected = Array.from(optionInputs)
        .filter(i => i.checked)
        .map(i => i.value);
      const match = variantData.find(v =>
        v.options.every((o, idx) => o === selected[idx])
      );
      if (!match) return;
      if (variantInput) variantInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? `<s>${formatMoney(match.compare_at_price)}</s> ${formatMoney(match.price)}`
          : formatMoney(match.price);
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? addBtn.dataset.labelAdd
          : addBtn.dataset.labelSoldOut;
      }
      if (match.featured_image && mainImg) {
        mainImg.src = match.featured_image;
      }
    };

    optionInputs.forEach(i => i.addEventListener('change', updateVariant));
  });
})();
